document.querySelectorAll('.js-scroll-to-section').forEach(el => {
  el.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = el.getAttribute('data-section-id');
    const target = document.querySelector(`${targetId}`);

    if (target) {
      const offset = 120;
      const topPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
      });
    }
  });
});

function initCollectionBannerCarousels() {
  if (window.innerWidth <= 991) return;

  document.querySelectorAll(".js-collection-banner-products-carousel").forEach((element) => {
    if (element.classList.contains('is-splide-mounted')) return;

    const splide = new Splide(element, {
      type: 'slide',
      gap: '6px',
      perPage: 1,
      rewind: false,
      arrows: false,
      pagination: false
    });

    splide.mount();
    element.classList.add('is-splide-mounted'); 
  });
}

function initCursorDragEffect() {
  const cursorDrag = document.querySelector('.js-cursor-drag');
  if (!cursorDrag) return;

  const body = document.body;
  let targetX = 0, targetY = 0, currentX = 0, currentY = 0;
  const speed = 0.1;

  const updateBounds = () => ({
    maxX: body.clientWidth - 80,
    maxY: body.clientHeight - cursorDrag.offsetHeight
  });

  document.addEventListener('mousemove', (e) => {
    const bounds = updateBounds();
    targetX = Math.min(bounds.maxX, Math.max(0, e.pageX));
    targetY = Math.min(bounds.maxY, Math.max(0, e.pageY));
  });

  function animate() {
    currentX += (targetX - currentX) * speed;
    currentY += (targetY - currentY) * speed;

    cursorDrag.style.left = `${currentX}px`;
    cursorDrag.style.top = `${currentY}px`;

    requestAnimationFrame(animate);
  }

  animate();

  document.querySelectorAll('.js-collection-banner-products-carousel').forEach(target => {
    target.addEventListener('mouseenter', () => cursorDrag.classList.add('active'));
    target.addEventListener('mouseleave', () => cursorDrag.classList.remove('active'));
  });
}


function wrapProductsAfterBanners() {
  const banners = document.querySelectorAll('.js-collection-banner-2');

  banners.forEach(banner => {
    if (banner.nextElementSibling?.classList.contains('product-group')) {
      return;
    }

    const groupWrapper = document.createElement('div');
    groupWrapper.classList.add('product-group');

    let next = banner.nextElementSibling;
    let count = 0;

    while (next && count < 4) {
      if (next.classList.contains('product-grid-item')) {
        const temp = next.nextElementSibling;
        groupWrapper.appendChild(next);
        next = temp;
        count++;
      } else {
        next = next.nextElementSibling;
      }
    }

    if (groupWrapper.children.length > 0) {
      banner.parentNode.insertBefore(groupWrapper, banner.nextElementSibling);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  wrapProductsAfterBanners();
  initCollectionBannerCarousels();
  initCursorDragEffect();
});

function initInfiniteScroll() {
  const loadMoreWrapper = document.querySelector('.js-load-more-wrapper');
  const productContainer = document.querySelector('.js-collection-results');

  if (!loadMoreWrapper || !productContainer) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loadMoreWrapper.classList.contains('loading')) {
        loadMoreWrapper.classList.add('loading');

        const url = loadMoreWrapper.dataset.url;
        fetch(url)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newProducts = doc.querySelectorAll('.js-collection-results > *');
            newProducts.forEach(el => productContainer.appendChild(el));

            const nextWrapper = doc.querySelector('.js-load-more-wrapper');
            if (nextWrapper) {
              loadMoreWrapper.dataset.url = nextWrapper.dataset.url;
              loadMoreWrapper.classList.remove('loading');
            } else {
              loadMoreWrapper.remove();
            }

            if (typeof wrapProductsAfterBanners === 'function') wrapProductsAfterBanners();
            if (typeof initCollectionBannerCarousels === 'function') initCollectionBannerCarousels();
            if (typeof initCursorDragEffect === 'function') initCursorDragEffect();
            if (typeof initializeObservers === 'function') initializeObservers();
            if (typeof initCollectionBannerAnimation === 'function') initCollectionBannerAnimation();
            if (typeof productGridForm === 'function') productGridForm();

            if (typeof _swat !== 'undefined' && typeof _swat.initializeActionButtons === 'function') {
              _swat.initializeActionButtons('body');
            }
          });
      }
    });
  }, {
    rootMargin: '200px',
  });

  observer.observe(loadMoreWrapper);
}

document.addEventListener('DOMContentLoaded', initInfiniteScroll);

function initCollectionBannerAnimation() {
  document.querySelectorAll('.js-collection-banner-button-image').forEach(banner => {
    if (banner.dataset.initialized === 'true') return;

    const block = banner.querySelector('.js-collection-banner-button-image-block');
    if (!block) return;

    banner.dataset.initialized = 'true';

    let targetX = 0, targetY = 0;
    let currentX = 0, currentY = 0;
    let mouseX = 0, mouseY = 0;
    let rect = banner.getBoundingClientRect();
    const blockWidth = block.offsetWidth;

    function lerp(start, end, speed) {
      return start + (end - start) * speed;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function updateTargetPosition() {
      rect = banner.getBoundingClientRect();

      const relativeX = mouseX - rect.left;
      const relativeY = mouseY - rect.top;

      const absoluteX = clamp(mouseX + 2, 0, document.body.clientWidth - blockWidth);

      targetX = absoluteX - rect.left;
      targetY = relativeY + 2;
    }

    function animate() {
      updateTargetPosition();
      currentX = lerp(currentX, targetX, 0.35);
      currentY = lerp(currentY, targetY, 0.35);

      block.style.transform = `translate(${currentX}px, ${currentY}px)`;
      requestAnimationFrame(animate);
    }

    document.body.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    window.addEventListener('scroll', () => {
      rect = banner.getBoundingClientRect();
    });

    rect = banner.getBoundingClientRect();
    mouseX = rect.left + rect.width / 2;
    mouseY = rect.top + rect.height / 2;
    updateTargetPosition();

    animate();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCollectionBannerAnimation();
});